import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export const UnavailableFeatureIcon = ({ className, ...props }) => (
  <svg
    width={15}
    height={15}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17.9 17.7"
    className={cx('unavailable-feature-icon', className)}
    {...props}
  >
    <path
      fill={'#bcc6ca'}
      d="M17.9 16.1l-7.5-7.3 7.4-7.4L16.4 0 8.9 7.4 1.4.1 0 1.6l7.5 7.3-7.4 7.4 1.4 1.4L9 10.2l7.5 7.4"
    />
  </svg>
);

UnavailableFeatureIcon.propTypes = {
  className: PropTypes.string
};

export default UnavailableFeatureIcon;
